import styled from "styled-components"

// PathItemWrapper
// gives max width to path items
// renders dividers between path items

export const PathListCointainer = styled.div`
  margin-top: 10px;
`

export const PathListWrapper = styled.ul`
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  list-style: none;
  padding-bottom: 50px;
`

export const PathItemWrapper = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
  max-width: 800px;
  padding: ${(p) => p.spacing || 10}px 10px;
  &:before,
  &:after {
    position: absolute;
    left: 0;
    right: 0;
    content: "";
    width: 2px;
    height: ${(p) => p.spacing || 10}px;
    margin: 0 auto;
    background-color: rgba(0, 0, 0, 0.1);
    opacity: ${(p) => (p.isDragging ? 0 : 1)};
  }
  &:before {
    top: 0;
  }
  &:after {
    bottom: 0;
  }
`

// PathLessonContainer
// gives shape to path lessons

export const PathLessonContainer = styled.div`
  position: relative;
  border-radius: 15px;
  padding: 10px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.05);
`

export const PathLessonHeader = styled.header`
  position: relative;
  padding: 20px 0;
`

export const PathLessonGrid = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style: none;
  & > li {
    width: 25%;
    padding: 10px;
    @media (max-width: 768px) {
      width: 33.3333%;
    }
    @media (max-width: 480px) {
      width: 50%;
    }
  }
`

export const PathResourceContainer = styled.div`
  position: relative;
  width: 100%;
  height: ${(p) => (p.layout === "grid" ? "auto" : "100px")};
`

export const PathLoadMoreWrapper = styled.div`
  position: relative;
  text-align: center;
  margin-top: 22px;
  .LoadingCircle {
    margin-top: 8px;
  }
`
